export const GET_MY_STATEMENTS_PENDING = 'GET_MY_STATEMENTS_PENDING'
export const GET_MY_STATEMENTS_SUCCESSFUL = 'GET_MY_STATEMENTS_SUCCESSFUL'
export const GET_MY_STATEMENTS_ERROR = 'GET_MY_STATEMENTS_ERROR'